export const helpCenterEmail = 'go-fmgatehelpcenter@kpmg.com'
export const supportPortalLink =
  'https://deliverybackbone.kpmg.com/studio/servicedesk/customer/portal/7/create/54'
export const sharepointLink =
  'https://deliverybackbone.kpmg.com/collaboration/display/public/XFRSOURCEGUIDE/Journey+Mapping+User+Guide'

export const pdfTutorial = '/DiscoveryUserManual.pdf'
